<template>
	<div>
		<div class="bg-white text-dark rounded shadow-lg p-3 p-md-4 mt-4">
			<div class="h1 text-center text-primary">{{ dt(promotion.title_translations) }}</div>

			<div v-for="product in promotion.whitelisted_store_products" :key="product.id">
				<div class="h3 text-center">{{ dt(product.name_translations) }} (共{{ promotion.period_count_limit }}期)</div>

        <template v-for="assort in product.assorts" :key="assort.id">
					<div class="row bg-faded-dark rounded p-3 mb-3">
						<div class="d-flex flex-column col-12 col-md-9" :style="borderStyle">
							<div class="h4">{{ dt(assort.name_translations) }}</div>
							<div class="text-muted text-wrap">{{ dt(assort.description_translations) }}</div>
						</div>
						<div class="d-flex flex-column justify-content-center col-12 col-md-3" :style="{ paddingLeft: isMobile ? '0' : '1rem' }">
							<div class="text-muted" :class="isMobile ? 'text-center' : 'text-left'">
								<span class="h4 text-muted">{{ assort.symbol }}{{ currencyFormat(assort.discounted_price) }}</span>
								<span>/{{ promotion.period_days }}天</span>
							</div>
							<span class="badge badge-warning">訂閱制</span>
						</div>
					</div>
				</template>
			</div>

			<a class="btn btn-primary btn-block mt-2" role="button" aria-disabled="true" href="#buyNow">
        立即搶購
      </a>

		</div>
		<div v-if="description_translations" class="bg-white text-dark rounded shadow-lg p-3 p-md-4 mt-4" style="font-size: 22px;font-weight:700;">
      <div v-html="description_translations"></div>
    </div>

    <a name="buyNow"></a>

    <div class="w-100">
    	<el-form
    		ref="ruleFormRef"
    		:model="form"
    		:rules="rules"
        label-position="top"
        label-width="120px"
    	>
    		<div class="col-12 no-padding-xs">

    			<div class="col-12 sector product-sector px-3">
    				<div class="row">

    					<div class="col-12 product-sector__content open">
    						<div>
    							<!-- table header -->
				          <div class="col-12">
				            <div class="product-sector__table-header d-none d-md-block">
				              <div class="table-head-sector">
				                <div class="table-head-title">{{ t("orders.productDetails") }}</div>
				                <div class="table-head-title">{{ t("orders.qty") }}</div>
				                <div class="table-head-title">{{ t("orders.price") }}</div>
				                <div class="table-head-title">&nbsp;</div>
				              </div>
				            </div>
				          </div>

                  <el-form-item prop="items" :rules="[{ type: 'array', validator: checkItem, trigger: 'change' }]">
				            <div class="col-12">
                      <div
                        v-for="(n, index) in assorts"
                        :key="n.id"
                        class="product-group"
                      >
                        <div class="product-group__content">
                          <div class="product-item row">
                            <div class="col-3 col-sm-2 product-item__col product-item__col--left">
                              <div class="product-item__img-block">
                                <div class="product-item__img">
                                  <img class="lazyload" :src="n.image_url">
                                </div>
                              </div>
                            </div>

                            <div class="col-9 col-sm-10 product-item__col product-item__col--right">
                              <div class="row">
                                <!-- 名稱 -->
                                <div class="col-10 col-md-5 product-item__name">
                                  <div class="product-item__name-main">
                                    <span>{{ n.product_name }}</span>
                                  </div>
                                  <div class="product-item__name-sub">
                                    <span v-if="n.discounted_price">
                                      {{ n.symbol }} {{ n.discounted_price }} - {{ dt(n.name_translations) }}
                                    </span>
                                    <span v-else>
                                      {{ n.symbol }} {{ n.sale_price }} - {{ dt(n.name_translations) }}
                                    </span>
                                  </div>
                                </div>

                                <!-- 數量 -->
                                <div class="col-6 col-md-4 product-item__qty">
                                  <div class="product-item__qty-select">
                                    <el-input-number
                                      v-model="n.buy_qty"
                                      :min=0
                                      :max="n.max_order_quantity"
                                    />
                                  </div>
                                  <div class="product-item__qty-hint">
                                    <span v-if="n.status == 'delete'">{{ t("carts.modelInvalid") }}</span>
                                    <span v-else-if="n.status != 'shelves'">{{ t("carts.ProductOff") }}</span>
                                    <span v-else-if="n.inventory < 10">
                                      {{ $t("carts.ProductRemaining", n.inventory, [n.inventory]) }}
                                    </span>
                                  </div>
                                </div>

                                <!-- 金額 -->
                                <div class="col-6 col-md-2 product-item__total-price">
                                  <span>{{ n.symbol }} {{ currencyFormat(n.discounted_price * n.buy_qty) }}</span>
                                </div>

                              </div>
                            </div>
                          </div>

                          <el-collapse-transition>
                            <div v-if="!!n.buy_qty && !!periodMap[n.id].conditions.length">
                              <div v-for="g in periodMap[n.id].conditions" :key="g.id" class="mb-4">
                                <ChooseGift
                                  :max-quantity="g.discountable_quantity"
                                  :period-count="g.period_count"
                                  :key-id="g.id.toString()"
                                  :data="g.choose_gifts"
                                />
                              </div>
                            </div>
                          </el-collapse-transition>
                        </div>
                      </div>
                    </div>
                  </el-form-item>
    						</div>
    					</div>
    				</div>
    			</div>

    			<LogisticInfo
            v-model="form"
            :available-logistic-types="availableLogisticTypes"
          ></LogisticInfo>

    			<PaymentInfo
            v-model="form"
            :available-payment-types="availablePaymentTypes"
            chk-logistic
          ></PaymentInfo>

    			<BuyerInfo v-model="form"></BuyerInfo>

    			<ToInfo v-model="form" :show-to-info="state.showToInfo">
            <div>
              <el-checkbox
                v-model="state.showToInfo"
                size="large"
              >
                {{ t("carts.differentBuyer") }}
              </el-checkbox>
            </div>

            <!-- 宅配 -->
            <ToHome
              ref="homeRef"
              v-model="form"
              v-model:state="state"
              :used-logistic-types="usedLogisticTypes"
              :provice-map="proviceMap"
              show-uads
              is-edit
            />
            <!-- 711門市 -->
            <ToCvs711
              ref="cvsPcscRef"
              v-model:form="form"
              v-model:state="state"
              :used-logistic-types="usedLogisticTypes"
              show-uads
              is-edit
            />
            <!-- 全家門市 -->
            <ToCvsFamily
              ref="cvsFamilyRef"
              v-model:form="form"
              v-model:state="state"
              :used-logistic-types="usedLogisticTypes"
              show-uads
              is-edit
            />
          </ToInfo>

          <InvoiceInfo
            v-if="showInvoice"
            v-model="form"
            :state="state"
            :provice-map="proviceMap"
            :used-logistic-types="usedLogisticTypes"
            :enableEInvoice="enableEInvoice"
            @change="handleSameHome"
          ></InvoiceInfo>

          <div class="col-12 sector memo-sector px-3">
            <div class="row">
              <div class="sector__header">
                {{ t('orders.memo') }}
                ({{ t('carts.optional') }})
              </div>
              <div class="sector__content">
                <div class="row">
                  <div class="col-12">
                    <el-input
                      v-model="form.memo"
                      :rows="3"
                      maxlength="35"
                      show-word-limit
                      type="textarea"
                      size="large"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Fixed Bottom -->
          <div class="checkout-footer-wrapper">
            <div class="checkout-footer">
              <div class="checkout-footer__left d-flex justify-content-start align-items-center flex-wrap">
                <div v-if="assortDiscount > 0" class="hidden-2xs">{{ t('orders.assortDiscount') }}:</div>
                <div v-if="assortDiscount > 0" class="hidden-2xs price">
                  -{{ state.currency_symbol }} {{ currencyFormat(assortDiscount) }}
                </div>
                <div v-if="promDiscount > 0" class="hidden-2xs">{{ t('orders.promDiscount') }}:</div>
                <div v-if="promDiscount > 0" class="hidden-2xs price">-{{ state.currency_symbol }}  {{ currencyFormat(promDiscount) }}</div>

                <div class="hidden-2xs">{{ t('orders.deliveryFees') }}:</div>
                <div class="hidden-2xs price">{{ state.currency_symbol }} {{ currencyFormat(deliveryFees) }}</div>

                <div v-if="deliveryFeesDiscount > 0" class="hidden-2xs">{{ t('orders.deliveryFeesDiscount') }}:</div>
                <div v-if="deliveryFeesDiscount > 0" class="hidden-2xs price">-{{ state.currency_symbol }} {{ currencyFormat(deliveryFeesDiscount) }}</div>

                <div>{{ t('carts.totalItemAndTotal', [cartCount]) }}:</div>
                <div class="price">{{ state.currency_symbol }} {{ currencyFormat(cartTotal) }}</div>
              </div>

              <div class="checkout-footer__right" @click="executeSubmit(ruleFormRef)">
                {{ t("global.next") }}
              </div>

            </div>
          </div>
    		</div>
    	</el-form>
    </div>

    <!-- <div class="d-md-none fixed-bottom bg-white" style="height: 46px;">
      <a class="btn btn-primary btn-block" role="button" aria-disabled="true" href="#buyNow">
        立即搶購
      </a>
    </div> -->
	</div>
</template>

<script setup>
import { reactive, ref, computed, watch, onMounted, toRaw } from 'vue'
import { _api_periodCheckoutCart } from "../api/index.js";
import {
  dataTranslations as dt, currencyFormat,
  parseVideoTag,
  breakpoint,
  notificationErrors,
  setLocalStorage,
  getLocalStorage,
  removeLocalStorage,
} from "../utils"
import { useI18n } from "vue-i18n"
import LogisticInfo from "./checkout/LogisticInfo.vue"
import PaymentInfo from "./checkout/PaymentInfo.vue"
import BuyerInfo from "./checkout/BuyerInfo.vue"
import ToInfo from "./checkout/ToInfo.vue"
import ToHome from './checkout/ToHome.vue'
import ToCvs711 from './checkout/ToCvs711.vue'
import ToCvsFamily from './checkout/ToCvsFamily.vue'
import InvoiceInfo from "./checkout/InvoiceInfo.vue"
import ChooseGift from "./ChooseGift.vue"

const props = defineProps({
  promotion: Object,
  modelValue: Object,
})

const { t, locale } = useI18n()
const data = ref(null)
const homeRef = ref()
const cvsPcscRef = ref()
const cvsFamilyRef = ref()
const assorts = ref([])

const isMobile = computed(() => breakpoint.value.xs || breakpoint.value.sm)
const borderStyle = computed(() => isMobile.value ? ({
  borderBottom: '5px solid #DBDBDB',
  paddingBottom: '.5rem',
  marginBottom: '.5rem',
}) : ({
  borderRight: '5px solid #DBDBDB',
}))
const ALERT_i18n = computed(() => ({
  input_error: t("errors.inputError"),
  required_login: t("errors.requiredLogin"),
  submit_error: t("errors.submitOrderError"),
}));
const getItems = computed(() => assorts.value.filter((elm) => elm.buy_qty > 0).map((elm) => ({
  store_product_id: elm.store_product_id,
  store_assort_id: elm.store_assort_id,
  quantity: elm.buy_qty,
})))

const tempCartName = `temp-cart-${props.promotion.id}`
const ruleFormRef = ref()
const form = reactive({
	// 活動
	event_id: props.promotion.id,
	event_type: props.promotion.type,
  // 購買者
  buyer_name: null,
  buyer_mobile: null,
  buyer_email: null,
  // 收件者
  uads_id: 0,
  to_name: null,
  to_mobile: null,
  to_email: null,
  country: null,
  province: null,
  city: null,
  region: null,
  postal_code: null,
  address: null,
  // 物流
  logistic_type: props.modelValue.logistics.length > 0 ? props.modelValue.logistics[0].type : null,
  // 金流
  payment_type: props.modelValue.payments.length > 0 ? props.modelValue.payments[0].type : null,
  // 發票
  invoice_type: "invoice",
  invoice_relation_option: "PAPER",
  invoice_relation_value: null,
  invoice_paper_no: null,
  invoice_paper_title: null,
  invoice_paper_relation_mobile: null,
  invoice_donate_code: "168001",
  invoice_province: null,
  invoice_city: null,
  invoice_region: null,
  invoice_postal_code: null,
  invoice_address: null,
  // 紅利
  coin_discount: 0,
  memo: null,
  cvs_711_shop_id: null,
  cvs_family_shop_id: null,
  cvs_711_shop_form: {
    province: null,
    distinct: null,
    road: null,
  },
  cvs_family_shop_form: {
    province: null,
    distinct: null,
    road: null,
  },
  uads_address: false,
  uads_cvs_family: false,
  uads_cvs_pcsc: false,
  items: [],
  event_group_gift_items: [],
})

const rules = reactive({
	// items: [
  //   { required: true, type: 'array', message: t('errors.pleaseSelect', [t("orders.productDetails")]), trigger: 'change' },
  // ],
	logistic_type: [
    { required: true, message: t('errors.pleaseSelect', [t("orders.shippingMethod")]), trigger: 'change' },
  ],
	payment_type: [
    { required: true, message: t('errors.pleaseSelect', [t("orders.paymentMethod")]), trigger: 'change' },
  ],
  buyer_name: [
    { required: true, message: t('errors.pleaseInput', [t("orders.buyerName")]), trigger: 'blur' },
  ],
  buyer_mobile: [
    { required: true, message: t('errors.pleaseInput', [t("orders.buyerPhone")]), trigger: 'blur' },
  ],
  to_name: [
    { required: true, message: t('errors.pleaseInput', [t("orders.toName")]), trigger: 'blur' },
  ],
  to_mobile: [
    { required: true, message: t('errors.pleaseInput', [t("orders.toPhone")]), trigger: 'blur' },
  ],
  province: [
    { required: true, message: t('errors.pleaseSelect', [t("users.province")]), trigger: 'change' },
  ],
  city: [
    { required: true, message: t('errors.pleaseSelect', [t("users.city")]), trigger: 'change' },
  ],
  region: [
    { required: true, message: t('errors.pleaseSelect', [t("users.region")]), trigger: 'change' },
  ],
  postal_code: [
    { required: true, message: t('errors.pleaseInput', [t("users.postcode")]), trigger: 'blur' },
  ],
  address: [
    { required: true, message: t('errors.pleaseInput', [t("orders.toAddress")]), trigger: 'blur' },
  ],
  cvs_711_shop_form: {
    province: [
      { required: true, message: t('errors.pleaseSelect', [t("users.province")]), trigger: 'change' },
    ],
    distinct: [
      { required: true, message: t('errors.pleaseSelect', [t("users.city")]), trigger: 'change' },
    ],
    road: [
      { required: true, message: t('errors.pleaseSelect', [t("users.road")]), trigger: 'change' },
    ],
  },

  cvs_711_shop_id: [
    { required: true, message: t('errors.pleaseSelect', [t("orders.mart")]), trigger: 'change' },
  ],
  cvs_family_shop_form: {
    province: [
      { required: true, message: t('errors.pleaseSelect', [t("users.province")]), trigger: 'change' },
    ],
    distinct: [
      { required: true, message: t('errors.pleaseSelect', [t("users.city")]), trigger: 'change' },
    ],
    road: [
      { required: true, message: t('errors.pleaseSelect', [t("users.road")]), trigger: 'change' },
    ],
  },
  cvs_family_shop_id: [
    { required: true, message: t('errors.pleaseSelect', [t("orders.mart")]), trigger: 'change' },
  ],
  invoice_type: [
    { required: true, message: t('errors.pleaseSelect', [t("invoices.type")]), trigger: 'change' },
  ],
  invoice_paper_no: [
    { required: true, message: t('errors.pleaseInput', [t("invoices.uniformNumbers")]), trigger: 'blur' },
  ],
  invoice_paper_title: [
    { required: true, message: t('errors.pleaseInput', [t("invoices.companyName")]), trigger: 'blur' },
  ],
  invoice_relation_value: [
    { required: true, message: t('errors.pleaseInput', [t("invoices.carrierCode")]), trigger: 'blur' },
  ],
  invoice_province: [
    { required: true, message: t('errors.pleaseSelect', [t("users.province")]), trigger: 'change' },
  ],
  invoice_city: [
    { required: true, message: t('errors.pleaseSelect', [t("users.city")]), trigger: 'change' },
  ],
  invoice_region: [
    { required: true, message: t('errors.pleaseSelect', [t("users.region")]), trigger: 'change' },
  ],
  invoice_postal_code: [
    { required: true, message: t('errors.pleaseInput', [t("users.postcode")]), trigger: 'blur' },
  ],
  invoice_address: [
    { required: true, message: t('errors.pleaseInput', [t("orders.toAddress")]), trigger: 'blur' },
  ],
})

const state = reactive({
	sameHome: true,
	showToInfo: false,
	currency: null,
  currency_symbol: null,
  currency_point: 0,
	invoice_type: 'PAPER',
	countryMap: null,
	// 711門市
  cvs_711_provinces: [],
  cvs_711_distincts: [],
  cvs_711_roads: [],
  cvs_711_shops: [],

  // 全家門市
  cvs_family_provinces: [],
  cvs_family_distincts: [],
  cvs_family_roads: [],
  cvs_family_shops: [],

  invoiceDonateOptions: [
    { label: "(168001) 財團法人ＯＭＧ關懷社會愛心基金會", value: "168001" },
    { label: "(1577) 社團法人中華民國自閉症總會", value: "1577" },
    { label: "(6274) 中華民國災難救援協會", value: "6274" },
  ],
})

const hasGoogleGa = computed(() => data.value?.trackers?.ga_ids.length > 0);
const hasFacebookPixel = computed(() => data.value?.trackers?.fbq_pixel_ids.length > 0);

const description_translations = computed(() => {
  if (props.promotion?.description_translations && !!Object.keys(props.promotion.description_translations).length) {
    let desc = dt(props.promotion.description_translations)
    return parseVideoTag(desc)
  }
  return null
})

const logisticMap = computed(() => _.keyBy(data.value.logistics, "type"));

const usedLogisticTypes = computed(() => {
  return [form.logistic_type];
});

const availableLogisticTypes = computed(() => {
  return data.value.logistics
})

const availablePaymentTypes = computed(() => {
	if (!form.logistic_type) {
 		return []
 	}
	// TODO: 需根據配送方式塞選可用金流
  return data.value.payments
})

const showInvoice = computed(() => data.value?.country === "TW");
const enableEInvoice = computed(() => {
  if (props.modelValue.invoice_type == "ELECTRONIC") {
    return true
  }
  return false
})

const proviceMap = computed(() => {
  if (form.country) {
    return state.countryMap?.province || {};
  }
  return {};
});

const periodMap = ref({})

const handleSameHome = (val) => {
  state.sameHome = val
}

const setCountryMap = (country) => {
  if (country) {
    const country_code = country.toLowerCase()
    axios({
      method: 'GET',
      url: "/api/v1/data/iso-3166-ext/"+country_code,
      headers: { 'Content-Type': 'application/json' },
    }).then((res) => {
      // console.log(res)
      state.countryMap = res.data
    })
    .catch((err) => {
      return Promise.reject(err.response)
    })
  } else {
    state.countryMap = {}
  }
}

const getAssorts = () => {
    let tmpAssorts = [];
    props.promotion.whitelisted_store_products.forEach((product) => {
  		product.assorts.forEach((assort) => {
  			let data = {
  				...assort,
  				store_product_id: product.id,
  				store_assort_id: assort.id,
  				image_url: assort.image_url ? assort.image_url : product.image_url,
  				product_name: dt(product.name_translations),
  				buy_qty: 0,
  			}
	  		tmpAssorts.push(data)
	  	})
	  })
    assorts.value = tmpAssorts
}

const getPeriods = () => {
  for (const assortId in props.promotion.discountable_store_product_assorts_map) {
    const assort = _.cloneDeep(props.promotion.discountable_store_product_assorts_map[assortId])
    assort.conditions.forEach((condition) => {
      const prods = props.promotion.discountable_store_products
        .filter((el) => condition.discountable_store_product_ids.includes(el.id))

      prods.forEach((el) => {
        el.assorts = el.assorts.map((assort) => ({ ...assort, quantity: null}))
      })
      condition.choose_gifts = _.cloneDeep(prods)
    })

    // console.log("assort", assort)
    periodMap.value[assortId] = assort
  }
}
const getPromotionDiscount = (promotion, assort_total, assort_count) => {
  let prom_discount = 0 // 活動折扣
  if (!promotion) return prom_discount

  let discount_type = promotion.discount_type
  let discount_value = null
  let choose_gift_store_product_ids = []
  let choose_gift_qty = 0

  // 滿額
  if (promotion.condition_min_type == 'amount') {
    promotion.conditions.forEach((condition) => {
      if (assort_total >= condition.min_amount) {
        if (discount_type == 'amount') {
          discount_value = condition.discount_amount
        } else if (discount_type == 'percentage') {
          discount_value = condition.discount_percentage
        } else if (discount_type == 'gift') {
          choose_gift_store_product_ids = condition.discountable_store_product_ids
          choose_gift_qty = condition.discountable_quantity
        }
      }
    })
  }
  // 滿件
  else if (promotion.condition_min_type == 'qty') {
    promotion.conditions.forEach((condition) => {
      if (assort_count >= condition.min_qty) {
        if (discount_type == 'amount') {
          discount_value = condition.discount_amount
        } else if (discount_type == 'percentage') {
          discount_value = condition.discount_percentage
        } else if (discount_type == 'gift') {
          choose_gift_store_product_ids = condition.discountable_store_product_ids
          choose_gift_qty = condition.discountable_quantity
        }
      }
    })
  }

  if (discount_type && discount_value) {
    if (discount_type == 'amount') {
      prom_discount = discount_value
    } else if (discount_type == 'percentage') {
      prom_discount = assort_total * (discount_value/100)
    }
  }

  const promDiscountableStoreProductMap = _.keyBy(promotion.discountable_store_products, "id")
  let choose_gifts = []
  choose_gift_store_product_ids.forEach((store_product_id) => {
      const gift = promDiscountableStoreProductMap[store_product_id.toString()]
      if (gift) {
        choose_gifts.push(gift)
      }
  })

  return {
    "prom_discount": formatFloat(prom_discount, data.value.currency_point),
    "choose_gifts": choose_gifts,
    "choose_gift_qty": choose_gift_qty,
  }
}

// 商品組合數量
const cartCount = computed(() => assorts.value.reduce((count, curr) => (count += curr.buy_qty ? curr.buy_qty : 0), 0));
// 組合原始總額
const assortRawTotal = computed(() => assorts.value.reduce((total, curr) => (total += curr.buy_qty ? curr.sale_price * curr.buy_qty : 0), 0));
// 組合折扣價總額
const assortTotal = computed(() => assorts.value.reduce((total, curr) => (total += curr.buy_qty ? curr.discounted_price * curr.buy_qty : 0), 0));

// 運費
const deliveryFees = computed(() => {
  let total = 0;
  if (form.logistic_type) {
  	total = logisticMap.value[form.logistic_type]._fee_amount
  }
  return formatFloat(total, data.value.currency_point);
});

// 運費折扣
const deliveryFeesDiscount = computed(() => {
  let total = 0;
  if (props.promotion.min_amount_free_shipping !== null & assortTotal.value >= props.promotion.min_amount_free_shipping) {
  	total = deliveryFees.value
  }
  return formatFloat(total, data.value.currency_point);
});

// 商品折扣
const assortDiscount = computed(() => {
  let total = 0;
  assorts.value.forEach((assort) => {
  	if (assort.buy_qty > 0) {
  		total += (assort.sale_price - assort.discounted_price) * assort.buy_qty
  	}
  })
  return formatFloat(total, data.value.currency_point);
})

// 活動折扣
const promDiscount = computed(() => {
  let total = 0;
  let prom_discount_info = getPromotionDiscount(props.promotion, assortTotal.value, cartCount.value)
  return formatFloat(total, data.value.currency_point);
})

// 結帳總額
const cartTotal = computed(() => {
  let total = assortRawTotal.value + deliveryFees.value - deliveryFeesDiscount.value - assortDiscount.value - promDiscount.value
  return total
})

const getEventGroupGiftItems = computed(() => {
  const event_group_gift_items = []
  const items = assorts.value.filter((elm) => elm.buy_qty > 0).map((elm) => elm.store_assort_id)
  // console.log("periodMap", Object.keys(periodMap.value).length, periodMap.value)
  if (Object.keys(periodMap.value).length) {
    for (const i in periodMap.value) {
      const el = periodMap.value[i]
      // console.log("period", toRaw(el))
      if (!items.includes(el.store_assort_id)) {
        continue
      }
      if (!!el.conditions) {
        el.conditions.forEach((condition) => {
          // console.log("condition", toRaw(condition))
          if (!!condition.choose_gifts) {
            condition.choose_gifts.forEach((gift) => {
              // console.log("gift", toRaw(gift))
              gift.assorts.forEach((assort) => {
                // console.log("assort", toRaw(assort))
                if (assort.quantity) {
                  event_group_gift_items.push({
                    condition_id: condition.id,
                    store_product_id: gift.id,
                    store_assort_id: assort.id,
                    quantity: assort.quantity,
                    cart_assort_id: el.store_assort_id,
                  })
                }
              })
            })
          }
        })
      }
    }
  }
  // console.log("items", toRaw(items))
  // console.log("event_group_gift_items", toRaw(event_group_gift_items))
  return event_group_gift_items
})

const checkItem = (rule, value) => {
  form.items = getItems.value

  if (!form.items.length) {
    return Promise.reject(t('errors.pleaseSelect', [t("orders.productDetails")]))
  }

  return Promise.resolve()
}

const executeSubmit = async (formEl) => {
	if (!formEl) return

  if (state.sameHome) {
    form.invoice_postal_code = form.postal_code
    form.invoice_province = form.province
    form.invoice_region = form.region
    form.invoice_city = form.city
    form.invoice_address = form.address
  }
  if (!state.showToInfo) {
    form.to_name = form.buyer_name
    form.to_mobile = form.buyer_mobile
  }

  // 活動贈品
  form.event_group_gift_items = getEventGroupGiftItems.value

  await formEl.validate(async (valid, fields) => {
    if (valid) {
      form.total_price = cartTotal.value

      // console.log("executeSubmit: ", toRaw(form))
      // 加入常用地址
      if (homeRef.value.addressRef?.isCreate) {
        await homeRef.value.addressRef.handleCreate()
      }
      if (cvsPcscRef.value.addressRef?.isCreate) {
        await cvsPcscRef.value.addressRef.handleCreate()
      }
      if (cvsFamilyRef.value.addressRef?.isCreate) {
        await cvsFamilyRef.value.addressRef.handleCreate()
      }

      window.fullPageLoading("show")
      _api_periodCheckoutCart(form)
        .then(async (res) => {
          if (res.status == 200) {
            // console.log("res: ", res.data)
            removeLocalStorage(tempCartName)

            // Facebook Pixel Code
            if (hasFacebookPixel.value) {
              await fbqTrackers.createEvent("AddPaymentInfo", res.data.fbq_custom_data)
            }
            // End Facebook Pixel Code
            const redirect_url = res.data.redirect_url
            window.location.assign(redirect_url)
          }
          else if (res.status == 422) {
            if (res.data.errors[0].type == 'CheckoutDataError') {
              const invalid_type = res.data.errors[0].invalid_type

              if (invalid_type == 'EVENT_GIFT_LOWER') {
                swal.fire('贈品不存在或已下架', 'error')
              } else if (invalid_type == 'EVENT_GIFT_OUT_OF_STOCK') {
                swal.fire('贈品庫存不足', 'error')
              } else if (invalid_type == 'EVENT_GIFT_EXCEED_QTY') {
                swal.fire('已超過可選擇贈品數量', 'error')
              } else {
                swal.fire(res.data.errors[0].msg, 'error')
              }
            } else {
              // swal.fire(ALERT_i18n.value.input_error, 'error')
              setTempSubmit();
              notificationErrors(res.data);
            }
          } else {
            // console.log(res.data.errors)
            setTempSubmit();
            notificationErrors(res.data);
            // swal.fire(ALERT_i18n.value.submit_error, 'error')
          }
        })
        .catch((error) => {
          setTempSubmit();
          notificationErrors(error);
          // swal.fire(ALERT_i18n.value.submit_error, 'error')
        })
        .finally(() => {
          window.fullPageLoading("hide")
        })

    } else {
      for (const key in fields) {
        if (["buyer_mobile", "buyer_name"].includes(key)) {
          formEl.scrollToField("buyer-info")
          break
        }
        else if (["to_name", "to_mobile"].includes(key)) {
          formEl.scrollToField("to-info")
          break
        }
        else if (["province", "city", "region", "postal_code", "address"].includes(key)) {
          formEl.scrollToField("to-info")
          break
        }
        else if (["cvs_711_shop_form.province", "cvs_711_shop_form.distinct", "cvs_711_shop_form.road", "cvs_711_shop_id"].includes(key)) {
          formEl.scrollToField("to-info")
          break
        }
        else if (["cvs_family_shop_form.province", "cvs_family_shop_form.distinct", "cvs_family_shop_form.road", "cvs_family_shop_id"].includes(key)) {
          formEl.scrollToField("to-info")
          break
        }
        else if (["invoice_relation_value", "invoice_paper_no", "invoice_paper_title"].includes(key)) {
          formEl.scrollToField("invoice")
          break
        }
        else {
          // console.log('error submit!', key)
          formEl.scrollToField(Object.keys(fields)[0])
          console.log('error submit!', fields)
          break
        }
      }
      return false
    }
  })
}
const setTempSubmit = () => {
  // console.log("tempSubmit: ", form)
  setLocalStorage(tempCartName, JSON.stringify(form))
}
const getTempSubmit = () => {
  // console.log("tempCartName: ", tempCartName)
  const tempCart = getLocalStorage(tempCartName)
  // console.log("tempSubmit: ", tempCart)
  if (tempCart) {
    Object.assign(form, { ...tempCart })
    // 有選取商品
    if (form.items.length) {
      // console.log("assorts: ", assorts.value)
      form.items.forEach((item) => {
        const assort = assorts.value.find((el) => el.id == item.store_assort_id)
        assort.buy_qty = item.quantity
      })
    }
    // 有選取贈品
    if (form.event_group_gift_items.length) {
      // console.log("periodMap: ", periodMap.value)
      const grouped = _.groupBy(form.event_group_gift_items, (item) => item.cart_assort_id)
      // console.log("grouped: ", grouped)
      for (const i in grouped) {
        const period = periodMap.value[i]
        const items = grouped[i]
        // console.log("period: ", toRaw(period))
        // console.log("items: ", toRaw(items))
        items.forEach((item) => {
          // console.log("item: ", toRaw(item))
          const condition = period.conditions.find((el) => el.id == item.condition_id)

          if (condition?.choose_gifts) {
            const giftAssort = condition.choose_gifts
              .find((el) => el.id == item.store_product_id)
              .assorts.find((el) => el.id == item.store_assort_id)
            giftAssort.quantity = item.quantity
            // console.log("giftAssort: ", toRaw(giftAssort))
          }
        })
      }
    }
  }
}


watch(
	() => props.modelValue,
  (val) => {
  	if (val) {
  		data.value = val
  		setCountryMap(val.country);

  		form.buyer_name = val.login_user.name
      form.buyer_mobile = val.login_user.mobile
      form.buyer_email = val.login_user.email
      form.to_name = val.login_user.name
      form.to_mobile = val.login_user.mobile
      form.to_email = val.login_user.email
      form.country = val.country

      state.invoice_type = val.invoice_type
      state.currency = val.currency
      state.currency_symbol = val.currency_symbol
      state.currency_point = val.currency_point
  	}
  },
	{ deep: true, immediate: true }
)

onMounted(async () => {
	await getAssorts()
	await getPeriods()
	getTempSubmit()
})
</script>
